interface IProps{
    margin: string;
}

export default function Separator({ margin }: IProps) {
  return (
    <div style={{ margin }} />
  );
}
